/* tslint:disable:indent */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {StringFunctions} from '../functions/string-functions';
import {API_ENDPOINTS} from '../api/api-endpoints';
import {Promotion} from '../models/promotion.model';

@Injectable({providedIn: 'root'})
export class PromotionService {

	getPromotions(): Observable<Promotion[]> {
		return this.http.post(
			API_ENDPOINTS.WCC.WCC_GET_PROMOTIONS,
			{}
		)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return this.toPromotionArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	updatePromotion(promotion: Promotion){
		return this.http.post(
			API_ENDPOINTS.WCC.WCC_UPDATE_PROMOTION,
			{
				promotion: promotion
			}
		);
	}

	updateSiteLinkedPromotion(website: number, promotion: number): Observable<any> {
		return this.http.post(
			API_ENDPOINTS.WCC.WCC_UPDATE_SITE_LINKED_PROMOTION,
			{
				website: website,
				promotion: promotion
			}
		);
	}

	removePromotion(promotionId: number): Observable<any> {
		return this.http.post(
			API_ENDPOINTS.WCC.WCC_REMOVE_PROMOTION,
			{promotion: promotionId}
		);
	}

	private toPromotionArray(data): Promotion[] {
		const promotion: Promotion[] = [];
		for (const item of data) {
			promotion.push(
				new Promotion(
					parseInt(item.Id, 10),
					StringFunctions.emptyToNull(item.Name),
					StringFunctions.emptyToNull(item.Description),
					StringFunctions.emptyToNull(item.MasterPromoText),
					StringFunctions.emptyToNull(item.HostingCoupon),
					StringFunctions.emptyToNull(item.HostingPromoText),
					StringFunctions.emptyToNull(item.StreamingCoupon),
					StringFunctions.emptyToNull(item.StreamingPromoText),
					StringFunctions.emptyToNull(item.ApplicationsCoupon),
					StringFunctions.emptyToNull(item.ApplicationsPromoText),
					StringFunctions.emptyToNull(item.ResellerHostingCoupon),
					StringFunctions.emptyToNull(item.ResellerHostingPromoText),
					StringFunctions.emptyToNull(item.ResellerStreamingCoupon),
					StringFunctions.emptyToNull(item.ResellerStreamingPromoText),
					(parseInt(item.CategoryOverridesMasterPromoText, 10) === 1)
				)
			);
		}
		return promotion;
	}

	constructor(private http: HttpClient) { }
}
